import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Prefetch likely next-page chunks based on the current route.
 * Uses requestIdleCallback so it never blocks the main thread.
 */
const PREFETCH_MAP: Record<string, Array<() => Promise<unknown>>> = {
  '/': [
    () => import('../pages/LocalLife'),
    () => import('../pages/NearMe'),
    () => import('../pages/Chat'),
    () => import('../pages/MyGem'),
  ],
  '/local-life': [
    () => import('../pages/PostDetail'),
    () => import('../pages/Index'),
  ],
  '/near-me': [
    () => import('../pages/Index'),
    () => import('../pages/Chat'),
  ],
  '/chat': [
    () => import('../pages/ChatDetail'),
    () => import('../pages/GroupChatDetail'),
  ],
  '/my-gem': [
    () => import('../pages/MyListings'),
    () => import('../pages/Settings'),
    () => import('../pages/Watchlist'),
  ],
};

export function useRoutePrefetch() {
  const { pathname } = useLocation();

  useEffect(() => {
    const imports = PREFETCH_MAP[pathname];
    if (!imports) return;

    const schedule = typeof requestIdleCallback === 'function'
      ? requestIdleCallback
      : (cb: () => void) => setTimeout(cb, 2000);

    const id = schedule(() => {
      imports.forEach(load => load().catch(() => {}));
    });

    return () => {
      if (typeof cancelIdleCallback === 'function') {
        cancelIdleCallback(id as number);
      }
    };
  }, [pathname]);
}
